import React, { Component } from 'react';

import EditArea from './EditArea.js';
import ImageSlider from './ImageSlider.js';

class AdminImage extends Component {

  constructor(props){
    super(props);

    this.img = this.props.data.project.image;

    this.state = ({
      svgAreas : this.props.data.items,
      hoverId:false,
      mouse: {x:0, y:0},
      toggle:false,
      points:null,
      dots: [],
      panelOpen:false,
      newArea:{},
      zoom:1,
      moveImage: {x:0,y:0},
      // imgId: Object.keys(this.props.data.project.images)[0]
      imgId: this.props.activeImgId
    })

    this.img = this.props.data.project.images[this.props.activeImgId];




    this.hoverHouse = this.hoverHouse.bind(this);
    this.closeInfo = this.closeInfo.bind(this);
    this.addNewSVG = this.addNewSVG.bind(this);
    this.addNewPoint = this.addNewPoint.bind(this);
    this.cleanArea = this.cleanArea.bind(this);
    this.saveArea = this.saveArea.bind(this);
    this.updateMousePos = this.updateMousePos.bind(this);
    this.openPanel = this.openPanel.bind(this);
    this.removeArea = this.removeArea.bind(this);
    this.escFunction = this.escFunction.bind(this);
    this.viewNextImage = this.viewNextImage.bind(this);
    this.lastY = 0;

    this.mouseDownPos = {x:0,y:0};
    this.mouseUpPos = {x:0,y:0};

  }

  escFunction(event){
    console.log('esc' + this.state.toggle);
    if(event.keyCode === 27) {
      //Do whatever when esc is pressed
      if(this.state.toggle){
        console.log('nu ska den stängas');
        this.openPanel(false);
        this.addNewSVG();


      }

    }
  }


  componentWillUpdate(props, state){

    if(this.props.activeImgId !== props.activeImgId){
      this.img = this.props.data.project.images[props.activeImgId];

      var img = new Image();
      img.src = this.img;

      img.onload = function(){
        this.setState({
          loading:false
        })
      }.bind(this);
    }


  }

  componentDidUpdate(){


  }

  componentDidMount(){
    document.addEventListener("keydown", this.escFunction, false);
  }
  componentWillUnmount(){
    document.removeEventListener("keydown", this.escFunction, false);
  }

  updateMousePos(_x, _y){
    this.setState({mouse:{
        x: _x,
        y: _y
      }
    });
  }

  hoverHouse(_id){
    this.setState({
      hoverId: 'text-' + _id
    });
  }

  closeInfo(){
    this.setState({
      hoverId: false
    })
  }

  addNewSVG(){
    var _state = (this.state.toggle)?false:true;

    this.setState({
      toggle: _state
    })
  }

  openPanel(_state){
    this.setState({
      panelOpen: _state
    });
  }


  addNewPoint(newPoints, newDots){
    this.setState({
      points: newPoints,
      dots: newDots
    });
  }

  saveArea(updatedArea){
    this.setState({
      svgAreas: updatedArea,
      dots: [],
      points:0
    });

    this.props.updateParentState(this.props.data, this.props.activeImgId);
  }
  cleanArea(){
    console.log('ta bort');
    this.setState({
      points:0,
      dots:[]
    })

  }

  removeArea(_id){

    // _id = 'area_' + _id;

    var newAreas = this.props.data.items;

    newAreas[_id].points[this.props.activeImgId] = null;

    this.setState({
      svgAreas: newAreas,
    })

    this.props.updateParentState(this.props.data, this.props.activeImgId);

    this.closeInfo();
  }

  getStatus(area){
    const areaStatus = this.props.data.items[area].status;
    let _string = '';

    switch (areaStatus) {
      case "available":
        _string = 'Tillgänglig';
        break;
      case "reserved":
        _string = 'Reserverad';
        break;
      case "sold":
        _string = 'Såld';
        break;
      default:

    }

    return (
      <span className={ areaStatus + ' status'}>
        {_string}
      </span>
    );
  }

  getAreaClass(area){
    const areaStatus = this.props.data.items[area].status;

    return areaStatus;
  }

  viewNextImage(){

    let countImages = Object.keys(this.props.data.project.images).length;

    let nextImgId = parseInt(this.props.activeImgId.replace('image', ''));
    if ( countImages - nextImgId === 0) {
      nextImgId = 1;
    }
    else {
      nextImgId += 1;
    }

    nextImgId = "image" + nextImgId;
    this.setState({
      // imgId: nextImgId,
      loading:true
    });

    this.props.updateParentState(this.props.data, nextImgId);

  }

  render() {
    let src = this.img;

    if(!this.props.data.items){
      return false;;
    }

    let countImages = Object.keys(this.props.data.project.images).length;


    return (
      <div id="area" className ="image-wrapper">

        <img alt="houses" className="main-image" src={src} />

        <div className="area-options">
          <div onClick={this.viewNextImage} className={(countImages > 1) ? "btn--small btn--icon" : "hidden"}><i className="fas fa-sync-alt"></i> Rotera vy</div>
        </div>

        <EditArea
          svgAreas = {this.props.data.items}
          dots = {this.state.dots}
          mouse = {this.state.mouse}
          points = {this.state.points}
          activeImgId = {this.props.activeImgId}
          viewBox = {this.props.viewBox}
          onClean = {this.cleanArea}
          onNewSvg = {this.addNewSVG}
          onAddPoint = {this.addNewPoint}
          onSave = {this.saveArea}
          toggle = {this.state.toggle}
          onMouseMove = {this.updateMousePos}
          newArea = {this.state.newArea}
          triggerPanel = {this.openPanel}
          panelOpen = {this.state.panelOpen}
          data = {this.props.data}
          zoom = {this.state.zoom}
        />


        <div className="hotspots" >
          <svg version="3.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
             viewBox={this.props.viewBox}>
            {

              Object.keys(this.props.data.items).map((area,key)=> {
                let objectPoints = (this.props.data.items[area].points) ? this.props.data.items[area].points[this.props.activeImgId] : null;

                return (
                  <g key={'g-'+ key} id={'area_' + area}
                    className={this.getAreaClass(area)}>
                    <polygon points={objectPoints} onClick={(e)=>this.hoverHouse(area)} />
                  </g>
                );
              })

            }
          </svg>
          <div className="info-wrapper">
            {
              Object.keys(this.props.data.items).map((area, key)=>(
                <div key={key} className={(this.state.hoverId === 'text-' + area ) ? 'show info' : 'hide info'}>
                  <ImageSlider />
                  <div className="icon icon-close" onClick={this.closeInfo}></div>


                  <h2>{this.props.data.items[area].title} </h2>
                  <p>{this.props.data.items[area].text} </p>
                  {this.getStatus(area)}

                  <ul>
                  {
                    Object.keys(this.props.data.items[area].info).map((info, _key)=>(
                      <li key={_key} title={this.props.data.items[area].info[info].title}>{this.props.data.items[area].info[info].text}</li>
                    ))
                  }
                  </ul>
                  <div className="btn--small btn-delete"
                       onClick={(e)=>this.removeArea( area )}>
                       Ta bort yta
                   </div>
                </div>
              ))
            }
          </div>
        </div>

        <div className={ (this.state.loading) ? 'loading' : 'loading loaded'}></div>

      </div>
    );
  }
}

export default AdminImage;



// WEBPACK FOOTER //
// ./src/AdminImage.js